// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body, html {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\na:hover, a:visited, a:link, a:active {\n    text-decoration: none!important;\n    -webkit-box-shadow: none!important;\n    box-shadow: none!important;\n}\n\n", ""]);
// Exports
module.exports = exports;
